export const LIMIT_OF_HOTEL_PROPOSAL = 5;
